import { render, staticRenderFns } from "./dateTem.vue?vue&type=template&id=4919d8be&scoped=true"
import script from "./dateTem.vue?vue&type=script&lang=js"
export * from "./dateTem.vue?vue&type=script&lang=js"
import style0 from "./dateTem.vue?vue&type=style&index=0&id=4919d8be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4919d8be",
  null
  
)

export default component.exports